import React from 'react';
import { Card } from '../ui/Card';
import { CreditCardIcon } from 'lucide-react';
export function DirectDebitTab() {
  return <div data-id="element-301">
      <Card title="Direct Debit Setup" data-id="element-302">
        <div className="flex items-center gap-3 mb-4" data-id="element-303">
          <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center" data-id="element-304">
            <CreditCardIcon className="w-5 h-5 text-blue-600" data-id="element-305" />
          </div>
          <div data-id="element-306">
            <h3 className="font-medium" data-id="element-307">No Direct Debit</h3>
            <p className="text-sm text-gray-500" data-id="element-308">
              This contact has no direct debit setup
            </p>
          </div>
        </div>
        <button className="text-blue-600 hover:text-blue-800 text-sm font-medium" data-id="element-309">
          + Setup Direct Debit
        </button>
      </Card>
    </div>;
}